import { observable, action, reaction } from 'mobx'
import agent from '@/Agent'

class CommonStore {
  @observable
  appName = 'Conduit'
  @observable
  token = window.localStorage.getItem('jwt')
  @observable
  appLoaded = false

  @observable
  tags = []
  @observable
  isLoadingTags = false

  @observable
  location = ''
  @observable
  locationHistory = []
  @observable
  isLoading = false
  @observable
  leaderboard = []
  @observable
  keySharedCredits = {}

  @observable
  replayed = false
  @action
  setReplayed(val) {
    this.replayed = val
  }

  getAppVersion() {
    return 'Ambassador Demo 1.0v'
  }
  constructor() {
    reaction(
      () => this.token,
      token => {
        if (token) {
          window.localStorage.setItem('jwt', token)
        } else {
          window.localStorage.removeItem('jwt')
        }
      }
    )
  }

  @action
  setToken(token) {
    this.token = token
  }

  @action
  clearToken() {
    this.token = undefined
    window.localStorage.removeItem('jwt')
  }

  @action
  setAppLoaded() {
    this.appLoaded = true
  }

  @action
  setLocation(location) {
    this.location = location
  }

  @action
  getLeaderboard() {
    this.isLoading = true
    return agent.Server.getLeaderboard()
      .then(data => {
        this.leaderboard = data
      })
      .finally(_ => {
        this.isLoading = false
      })
  }

  @action
  getKeySharedCredits() {
    this.isLoading = true
    return agent.Server.getKeySharedCredits()
      .then(data => {
        this.keySharedCredits = data
      })
      .catch(err => {
        console.log(err.message)
      })
      .finally(_ => {
        this.isLoading = false
      })
  }

  displayAwards(item, cause) {
    const abbr = { points: 'PTS', tokens: 'TKNS', stars: 'STARS' }
    let lines = []
    let stats = {}
    for (let currency of Object.keys(abbr)) {
      if (!item[currency]) continue
      const letter = currency.substring(0, 1)
      let s = abbr[currency] + ':'
      if (
        ['prize', 'sponsor'].indexOf(item.type.toLowerCase()) === -1 &&
        (!item.currencyFixed || item.currencyFixed.indexOf(letter) === -1)
      )
        s += 'x'
      if (s.includes('PTS')) {
        stats.points = s.includes('PTS:x')
          ? `x${item[currency]}`
          : `${item[currency]}`
      }
      if (s.includes('TKNS')) {
        stats.tokens = `${item[currency]}`
      }
      if (s.includes('STARS')) {
        stats.stars = `${item[currency]}`
      }
      s += item[currency]
      lines.push(s)
    }
    return cause === 'PlayItemUnresolved' ? stats : lines.join(' ')
  }

  @observable
  selectionMode = {}
  @action
  setSelectionClickStatus(mode) {
    this.selectionMode = this.selectionMode || {}
    this.selectionMode[`is${mode}Mode`] = this.selectionMode[`is${mode}Mode`]
      ? !this.selectionMode[`is${mode}Mode`]
      : true
    if (!this.selectionMode.isSMode) {
      this.resetSelectionMode()
    }
  }

  @action
  resetSelectionMode() {
    this.selectionMode.sModePlays = []
    this.selectionMode.isSMode = false
    this.selectionMode.isLMode = false
    this.selectionMode.destinationItem = null
  }

  @action
  setSModePlays(val) {
    this.selectionMode.sModePlays = val || []
  }

  @action
  setDestinationItem(val) {
    this.selectionMode.destinationItem = val
  }
}

export default new CommonStore()



// WEBPACK FOOTER //
// src/stores/CommonStore.js